import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  api: string = environment.apiEndPoint;

  constructor(private http: HttpClient) { }

   // ---- Get Province Meta Data ---- //        
   getCityProvinceMetaData() {
    return this.http.get( this.api+'/RegBusiness');
  }

  // ---- Meta Data ---- //
  getBusinessMetaData() {
    return this.http.get( this.api+'/Business/GetBusinessSD');
  }

  // ---- Register ---- //
  register(data: any) {
    return this.http.post(this.api+'/RegBusiness', data);
  }

  // ---- Verify Pin Code ---- //
  verifyPinCode(userPin: any) {
    return this.http.put(this.api+ '/User/VerifyPin', userPin);
  }

  // ---- Send Verification Code ---- //
  sendVerificationCode(data: any) {
    return this.http.put(this.api+'/User/GeneratePin', data);
  }

  resetPasswordVerifyPhone(data: any) {
    return this.http.put(this.api+'/Auth/ResetPassword', data);
  }

  // ---- Update Password ---- ///
  updatePassword(data: any) {
    return this.http.put(this.api+'/Auth/UpdatePassword', data);
  }

  // -- Password Reset -- //
  resetPassword(data: any) {
    return this.http.put(this.api+'/Auth/ResetPassword', data);
  }

  // -- Submit Profile -- //
  submitProfile(data: any) {
    return this.http.put(this.api+'/User/UpdateStatus', data);
  }
}
